import { resolveAssetUrl } from '../../../shared/utils/assetUrl';
import i18n from '../../../i18n';
import { entityText } from '../../../i18n/entityText';

export const COIN_ICON = '/coin_icon.png';
export const RANDOM_MODULE_ICON = '/module_random.png';
export const DNA_ICON = '/lair/dna.svg';
export const LIVES_ICON = '/lair/heart.svg';

/** Icon for a mission reward / claimed reward / cost line. */
export function rewardIcon(reward) {
  if (!reward) return null;
  if (reward.imageUrl) return resolveAssetUrl(reward.imageUrl);
  if (reward.rewardType === 'COINS' || reward.code === 'COINS') return COIN_ICON;
  if (reward.resourceCode === 'DNA' || reward.code === 'DNA') return DNA_ICON;
  if (reward.rewardType === 'CHARACTER_MODULE') return RANDOM_MODULE_ICON;
  return null;
}

/** Display name for a reward line (translated: lair_resource by code, character_module by id). */
export function rewardName(reward, t = i18n.t.bind(i18n)) {
  if (!reward) return '';
  if (reward.rewardType === 'COINS') return t('reward.coins', 'Coins');
  if (reward.resourceCode && reward.name) return entityText(t, 'lair_resource', reward.resourceCode, 'name', reward.name);
  if (reward.rewardType === 'CHARACTER_MODULE') {
    if (reward.moduleId && reward.name) return entityText(t, 'character_module', reward.moduleId, 'name', reward.name);
    return reward.name || t('reward.random_module', 'Random module');
  }
  if (reward.name) return reward.name;
  return reward.resourceCode || reward.rewardType || '';
}

export { resolveAssetUrl };

/** Translated mission name of a MissionRunDTO / mission config ({missionId|id, missionName|name}). */
export function missionName(mission, t = i18n.t.bind(i18n)) {
  if (!mission) return '';
  const id = mission.missionId ?? mission.id;
  const name = mission.missionName ?? mission.name;
  return entityText(t, 'mission_config', id, 'name', name) || '';
}

/** Translated name of a lair farm (lair_buildings). */
export function buildingName(building, t = i18n.t.bind(i18n)) {
  if (!building) return '';
  return entityText(t, 'lair_building', building.id, 'name', building.name) || '';
}
